export default __webpack_public_path__ + "static/cr-reorder-list-gif-ae4ab542fbebe015c9b5dc8fbe6b2a03.mp4";